/**
 * Check if a value is a string.
 */
const isString = (value: unknown): value is string =>
  typeof value === 'string' || value instanceof String;

export default isString;
